<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'daftar-outlet-autosender'" :bg-grey="true">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Daftar Outlet Autosender" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-x-20">
                    <div class="m-d-16 h-perangkat">
                        <div class="d-flex" style="align-items: center;">
                            <div class="m-d-0 f-12 f-semi f-c-midgrey">
                                <span>Tampilkan:</span>
                            </div>
                            <div class="m-d-0 f-c-blue m-l-4 d-flex-between-center f-12 f-regular" @click="doAction">
                                <div class="no-telp" v-if="getDeviceNumber">
                                    <IconBased width="14" height="14">
                                        <template v-slot:icons>
                                            <WhatsappIconMini clr-fill="#206CFF" />
                                        </template>
                                    </IconBased>
                                    <span class="m-l-4">+{{ getCC }}{{ getDeviceNumber }}</span>
                                </div>
                                <div class="d-flex-between-center">
                                    <p class="m-d-0 f-12 f-regular f-cont nama-device" style="margin-right: 4px">
                                        {{ getDeviceName }}
                                    </p>
                                    <IconBased width="12" height="6">
                                        <template v-slot:icons>
                                            <ArrowDown />
                                        </template>
                                    </IconBased>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-t-16 m-d-16">
                        <p class="f-c-midgrey f-16 f-regular">{{ totalOutlet }} Outlet terhubung</p>
                    </div>
                    <div>
                        <CardOutlet :data-list="listOutlet" />
                    </div>
                    <div>
                        <div class="flying-button-wrapper">
                            <div class="flying-inside">
                                <a class="flying-button" @click="gotoIntegrasiOutlet"></a>
                            </div>
                        </div>
                    </div>
                    <!-- <SOLoadMoreLoading :id="'load-more-mesin-edc'" :loading="isLoadMore" /> -->
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import IconBased from "../../components/iconPack/IconBased.vue";
import ArrowDown from "../../components/iconPack/ArrowDown1206.vue";
import WhatsappIconMini from "../../components/iconPack/WhatsappIcon1414.vue";

import CardOutlet from "../../components/CardOutlet.vue";

import { moduleName } from "../../store/state";

export default {
    name: "ListOutlet",
    components: {
        SOSlotBase,
        SOTitleBar,
        IconBased,
        ArrowDown,
        WhatsappIconMini,
        CardOutlet,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "wa_autosender.detail_perangkat") {
                vm.getDetailTinyDevice({ id_mesin: vm.$route.params.id_device });
            }
        });
    },
    mounted() {
        this.init();
        this.smartTrackingView('outlet_integrasi_whatsapp')

    },
    watch: {
        dataDeviceTiny: function(newVal, oldVal) {
            if (newVal.number) {
                this.setDevice({ type: "nama", data: newVal.nama });
                this.setDevice({ type: "nomor", data: newVal.number });
                this.setDevice({ type: "iddevice", data: newVal.iddevice });
                this.setDevice({ type: "country_code", data: newVal.country_code });
            }
        },
        getIdDevice: function(newVal, oldVal) {
            if (!this.isFetching) {
                if (newVal !== oldVal) {
                    this.loadDataOutlet();
                }
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            listOutlet: "listOutlet",
            totalOutlet: "totalOutlet",
            dataDevice: "dataDevice",
            dataDeviceTiny: "dataDeviceTiny",
            device: "device",
            response: "response",
            isFetching: "isFetching",
        }),
        getDeviceNumber() {
            return this.device?.nomor || "";
        },
        getCC() {
            return this.device?.country_code || this.dataDeviceTiny.country_code;
        },
        getDeviceName() {
            return this.device?.nama;
        },
        getIdDevice() {
            return this.device.nama ? this.device.iddevice : this.$route.params.id_device;
        },
    },
    methods: {
        ...mapActions({
            getListOutlet: `${moduleName}/getListOutlet`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            setIntegrasiOutlet: `${moduleName}/setIntegrasiOutlet`,
            setDevice: `${moduleName}/setDevice`,
            resetListOutlet: `${moduleName}/resetListOutlet`,
            resetDataDeviceTiny: `${moduleName}/resetDataDeviceTiny`,
        }),
        init() {
            if (!this.dataDevice.nomor) {
                this.getDetailTinyDevice({ id_mesin: this.$route.params.id_device });
            } else {
                this.setDevice({ type: "nama", data: this.dataDevice.nama });
                this.setDevice({ type: "country_code", data: this.dataDevice.country_code });
                this.setDevice({ type: "nomor", data: this.dataDevice.nomor });
                this.setDevice({ type: "iddevice", data: this.dataDevice.iddevice });
            }
            if (this.listOutlet.length === 0) {
                this.loadDataOutlet();
            }
        },
        loadDataOutlet() {
            this.resetListOutlet();
            this.getListOutlet({ iddevice: this.getIdDevice });
        },
        back() {
            this.resetListOutlet();
            this.resetDataDeviceTiny();
            this.$router.push({ name: "wa_autosender.detail_perangkat" });
        },

        gotoIntegrasiOutlet() {
            this.setIntegrasiOutlet({ type: "idoutlet", data: null });
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.integrasi" });
            this.smartTrackingClick('add_outlet_integrasi_whatsapp')

        },
        async doAction() {
            this.$router.push({ name: "wa_autosender.detail_perangkat.daftar_oulet.show_perangkat" });
        },
    },
};
</script>
<style scoped>
.h-perangkat {
    background-color: #ffffff;
    margin: 0px -20px;
    padding: 8px 20px;
}
.no-telp {
    border: 1px solid #ededed;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 4px;
    margin-right: 4px;
}

.nama-device {
    max-width: 57px;
}
@media (min-width: 320px) {
    .nama-device {
        max-width: 80px;
    }
}
@media (min-width: 350px) {
    .nama-device {
        max-width: 120px;
    }
}
@media (min-width: 400px) {
    .nama-device {
        max-width: 170px;
    }
}
@media (min-width: 420px) {
    .nama-device {
        max-width: 190px;
    }
}
@media (min-width: 450px) {
    .nama-device {
        max-width: 220px;
    }
}
</style>
